import { formatAnswerSheetQuestionNo, shouldShowQuestionScore } from '../../../assets/utils/utils';
import sheet from '../../../styles/components/answerSheet.module.scss';

const TestCheckboxPreviewButtons = ({ id, options, score, quNo, isInfo, isRank, quizType, userAnswered }) => {
    const showScore = shouldShowQuestionScore(quizType, isRank);

    const getSelectedOptionId = () => {
        if (!userAnswered) return null;
        const found = userAnswered.find((a) => a.id === id);
        return found?.option_id ?? null;
    };

    const selectedOptionId = getSelectedOptionId();
    const options_list = [
        { id: 1, option_number: 1 },
        { id: 2, option_number: 2 },
        { id: 3, option_number: 3 },
        { id: 4, option_number: 4 },
    ];
    const displayOptions = (options && options.length > 0) ? options : options_list;

    return (
        <li key={id} style={{ listStyle: 'none', paddingRight: 0 }}>
            <div className={`${sheet.sheetRow} ${!showScore ? sheet.sheetRowNoGrade : ''}`}>
                <span className={sheet.questionNo}>{formatAnswerSheetQuestionNo(quNo)}</span>
                <div className={sheet.optionsGrid}>
                    {displayOptions?.map((el) => (
                        <div
                            key={el.id}
                            className={`${sheet.optionBtn} ${selectedOptionId === el.id ? sheet.optionBtnActive : ''}`}
                        >
                            {el.option_number}
                        </div>
                    ))}
                </div>
                {showScore && (
                    <div className={sheet.gradeCol}>
                        <span className={sheet.gradeValue}>{score}</span>
                        <span className={sheet.gradeLabel}>بارم</span>
                    </div>
                )}
            </div>
        </li>
    );
};

export default TestCheckboxPreviewButtons;
